
  <mat-toolbar>{{"Select User(S) To Add" | translate | async}}</mat-toolbar>
  <div class="DialogBoxEL">
<div class="SelectUser">
  
  <!--<h4>Job Site</h4>-->

  <mat-form-field class="MFF">
    <mat-label>{{"Job Site" | translate | async}}</mat-label>
     <mat-select  (selectionChange)="jobsiteChanged($event)"[(ngModel)]="selectedSiteId">
      <mat-option *ngFor="let option of jobsitebyCustomerID" [value]="option.crsf_auto">
        {{option.site_name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div class="SetectEqp">
  <!--<h4>Equipments</h4>-->
  <mat-form-field class="MFF">
    <mat-label>{{"Equipments" | translate | async}}</mat-label>
     <mat-select  [(ngModel)]="selectedEQId">
      <mat-option *ngFor="let contain of equipmnentList" [value]="contain.EquipmentId">
        {{contain.UnitNo}}
      </mat-option>
    </mat-select>
  </mat-form-field>


</div>
<div class="UserListMain">
  <h4>{{"User" | translate | async}}</h4>
  <div>
  <mat-selection-list  #arra1 [(ngModel)]="selectedOptions1" class="UserList" >
    <mat-list-option *ngFor="let item of array1" [value]="item">
      {{item.userName | aesDecrypt}}
    </mat-list-option>
  </mat-selection-list>
  </div> 
  

     <div class="AddOrReBtn">
      <button mat-stroked-button class="AddBtn" (click)="AddItem()">>></button>
      <button mat-stroked-button class="RemoveBtn" (click)="RemoveItem()"><<</button>
    </div>
    
    
      
    <div>
      <mat-selection-list  #arra2 [(ngModel)]="selectedOptions2" class="UserList" >
        <mat-list-option *ngFor="let item of array2" [value]="item">
          {{item.userName | aesDecrypt}}
        </mat-list-option>
      </mat-selection-list>
      </div>
  </div>
  

  <div class="DialogBoxELBtn">
    <button mat-stroked-button class="AddNewUserELAddBtn" (click)="AddNewEL()">{{"Add" | translate | async}}</button>
    <button mat-stroked-button class="AddNewUserELClsBtn" (click)="DialogClose()">{{"Close" | translate | async}}</button>
  </div>

